export class DashboardModel {

    public constructor(
        public readonly isInit: boolean,
        public readonly vacationStatModel: VacationStatModel,
        public readonly upcomingEventsModel: UpcomingEventsModel
    ) { }

}

export class VacationStatModel {

    public constructor(
        public readonly annualVacationCount: string,
        public readonly carriedVacationCount: string,
        public readonly usedUpVacationCount: string,
        public readonly remainingVacationCount: string,
    ) { }

}

export class UpcomingEventsModel {

    public readonly events: UpcomingEventItem[] = [];

    public constructor() { }

}

export class UpcomingEventItem {

    public constructor(
        public readonly icon: string,
        public readonly iconColor: string,
        public readonly title: string,
        public readonly date: string,
        public readonly description: string
    ) { }

}